/**
 * « Employés à connecter une fois en ligne » (design 4.1, etape 5) : chaque
 * employe actif du magasin, avec une coche quand son NIP est deja reconnu
 * sur ce poste (verificateur en cache). Jamais la couleur seule : icone et texte.
 */
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { hasUsableVerifier } from './pinVerifier';
import { palette } from './theme';

export default function EmployeeChecklist({ employees }) {
    const active = (employees || [])
        .filter((e) => !e.revoked)
        .sort((a, b) => String(a.display_name).localeCompare(String(b.display_name), 'fr-CA'));
    const done = active.filter(hasUsableVerifier).length;
    return (
        <Box data-testid="liste-employes" sx={{ width: '100%', maxWidth: 640 }}>
            <Typography component="h2" sx={{ fontSize: 22, fontWeight: 800, color: palette.text }}>
                Employés à connecter une fois en ligne
            </Typography>
            <Typography sx={{ fontSize: 16, color: palette.textSecondary, mb: 1 }}>
                {active.length === 0
                    ? 'Aucun employé actif reçu de l\'ERP pour ce magasin.'
                    : `${done} sur ${active.length} déjà reconnus sur ce poste`}
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', m: 0, p: 0, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                {active.map((employee) => {
                    const cached = hasUsableVerifier(employee);
                    let status = 'À connecter une fois en ligne';
                    if (cached) status = 'Reconnu sur ce poste';
                    else if (employee.has_pin === false) status = 'Aucun NIP dans l\'ERP';
                    return (
                        <Box
                            component="li"
                            key={employee.employee_id}
                            data-testid={`employe-${employee.employee_id}`}
                            data-reconnu={cached ? 'oui' : 'non'}
                            sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 0.5, fontSize: 18 }}
                        >
                            {cached
                                ? <CheckCircleIcon aria-hidden="true" sx={{ color: palette.successOnTint }} />
                                : <RadioButtonUncheckedIcon aria-hidden="true" sx={{ color: palette.textMuted }} />}
                            <Typography sx={{ fontSize: 18, fontWeight: 600, flex: 1 }}>{employee.display_name}</Typography>
                            <Typography sx={{ fontSize: 16, color: cached ? palette.successOnTint : palette.textSecondary }}>{status}</Typography>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}
